// Same separators the backend splits a pasted list on (ParseInput::SEPARATORS).
const SEPARATORS = /[\r\n,;]+/;

// Whether the submitted text holds anything at all that could be an id.
//
// Used to word a 422: `no_account_ids` is the only code the backend can answer
// with when it read no id out of the request — the other payload errors
// (too many ids, registry full) all need parsed ids to happen. This does not
// pre-empt the request; only the backend decides what is accepted.
export function hasParsableId(text: string): boolean {
  return text.split(SEPARATORS).some((value) => value.trim() !== '');
}
